import { createAction } from "@ngrx/store";

export const copiedToClipboard = createAction(
    '[Shared] copied to clipboard'
)

export const copiedToClipboardError = createAction(
    '[Shared] error while copying to clipboard'
)